<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">Manage Anyo Packs</h1>
    </div>
  </div>
  
<button 
    [routerLink]="['/packs/curd']"
    nz-button nzType="primary" >Create anyo pack</button>
  </div>
<div class="flex justify-end mt-3">
  <div class="w-[40%]">
    <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
      <input
        type="text"
        nz-input
        [(ngModel)]="globalSearchInput"
        placeholder="Search pack by pack name"
      />
    </nz-input-group>
  </div>
</div>
<ng-template #suffixButton>
  <button
    nz-button
    nzType="primary"
    nzSize="small"
    nzSearch
    (click)="fetchAnyoPacks()"
  >
    Search
  </button>
</ng-template>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Packs</span>
    </div>
    <div nz-col class="space-x-3">
      <nz-switch
        [(ngModel)]="testPacks"
        (ngModelChange)="testPacksChangeFn($event)"
        nzCheckedChildren="Hide Test Events"
        nzUnCheckedChildren="Show Test Events"
      ></nz-switch>
      <button
        class="btn-color"
        nz-button
        nzSize="small"
        nzType="primary"
        (click)="resetFilter()"
      >
        Clear filter
      </button>
    </div>
  </div>
</ng-template>
<nz-spin [nzSpinning]="tableLoading" nzTip="Fetching packs....">
  <div class="table-container">
    <nz-table
      #basicTable
      [nzData]="tableData"
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalRecords"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="page"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>Pack Name</th>
          <th>Internal Pack name</th>
          <th>
            Visible:
            <nz-switch
              [ngModel]="isVisible"
              (ngModelChange)="onToggleVisible($event)"
              [nzCheckedChildren]="'true'"
              [nzUnCheckedChildren]="'false'"
            ></nz-switch>
          </th>

          <th>
            Active:
            <nz-switch
              [ngModel]="isActive"
              (ngModelChange)="onToggleActive($event)"
              [nzCheckedChildren]="'true'"
              [nzUnCheckedChildren]="'false'"
            ></nz-switch>
          </th>

          <th nzWidth="20%">Primary Therapist Details</th>
          <th nzWidth="30%">Auxilary Therapist Details</th>
          <!-- <th>Primary Therapist Expertise</th>
          <th>Primary Therapist</th> -->
          <th nzWidth="10%">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>
            <button
              (click)="openTherapyPlansSubscriptionPageByPlanName(data.id)"
              class="underline bg-transparent border-none p-0 text-left cursor-pointer"
              style="text-decoration: underline"
              (keydown.enter)="
                openTherapyPlansSubscriptionPageByPlanName(data.id)
              "
            >
              {{ data.packName }}
            </button>
          </td>
          <td>{{ data.internalPackName }}</td>
          <td>{{ data.visible }}</td>
          <td>{{ data.active }}</td>
          <!-- <td>
           
          </td> -->
          <td>
            
            <ng-container
            *ngFor="let concern of getConcernNames(data.primaryConcern)"
          >
          Primary Concern : <nz-tag [nzColor]="'blue'">{{ concern }}</nz-tag>
          </ng-container>
            <br/>
            Expertise On : 
            <ng-container>
              <nz-tag class="mt-2 mb-2" [nzColor]="'green'">{{
                data.primaryTherapistExpertiseName
              }}</nz-tag>
            </ng-container>
            <br/>
            Experts :
            {{
              data.primaryTherapistDetails.length
                ? data.primaryTherapistDetails
                : "N/A"
            }}
          </td>
          <td>
            <div 
            *ngFor="let th of data.auxilaryTherapistDetails,index as i"
            class="flex flex-col gap-2 mt-2 mb-2"
            >
            <div class="flex flex-col gap-2">
              <h1>{{
               i + 1 +")Expert Name : " + th.therapistName
              }}</h1>
                Expertise On : 
              <div class="flex flex-wrap">
                <nz-tag class="mt-1 mb-1" *ngFor="let tag of th.expertiseName" [nzColor]="'purple'">{{
                  tag
                }}</nz-tag>
              </div>
            </div>
            </div>
          </td>

          <!-- <td>
            
          </td> -->

          <td>
            <div class="flex flex-row gap-2">
              <button
                nz-button
                nzType="default"
                nzSize="small"
                nzShape="round"
                [routerLink]="['/packs/curd', data.id]"
                class="flex flex-row items-center gap-1"
                nz-tooltip="View Pack"
              >
                <i nz-icon nzType="eye" nzTheme="outline"></i>
              </button>

              <button
                nz-button
                nzType="primary"
                nzSize="small"
                nzShape="round"
                (click)="onAddSubscription(data.id)"
                class="flex flex-row items-center gap-1"
                nz-tooltip="Add Pack Subscription"
              >
                <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>

<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="700"
  [nzVisible]="openAddPackSubscriptionDrawer"
  nzTitle="Add Pack Subscription"
  (nzOnClose)="handleCloseDrawer()"
>
  <ng-container *nzDrawerContent>
    <nz-spin [nzSpinning]="drawerLoading" nzTip="Adding subscription....">
      <form
        nz-form
        [formGroup]="addPackSubscriptionForm"
        (ngSubmit)="onSubmit()"
        nzLayout="vertical"
      >
        <!-- User Email -->
        <nz-divider nzText="Basic details"></nz-divider>
        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="userEmail" nzRequired>User Email</nz-form-label>
          <nz-form-control [nzErrorTip]="'User email is required'">
            <input
              nz-input
              formControlName="userEmail"
              id="userEmail"
              placeholder="Enter user email"
            />
          </nz-form-control>
        </nz-form-item>

        <!-- Payment Order ID -->
        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="paymentOrderId" nzRequired
            >Payment Order ID</nz-form-label
          >
          <nz-form-control [nzErrorTip]="'Payment Order ID is required'">
            <input
              nz-input
              formControlName="paymentOrderId"
              id="paymentOrderId"
              placeholder="Enter payment order ID"
            />
          </nz-form-control>
        </nz-form-item>

        <!-- Variation ID (Dropdown) -->
        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="variationId" nzRequired
            >Variation ID</nz-form-label
          >
          <nz-form-control [nzErrorTip]="'Please select a variation'">
            <nz-select
              formControlName="variationId"
              nzPlaceHolder="Select Variation"
            >
              <nz-option
                *ngFor="let item of variationOptions"
                [nzValue]="item.value"
                [nzLabel]="item.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="auxiliaryConcernId" nzRequired
            >Auxiliary Concern</nz-form-label
          >
          <nz-form-control [nzErrorTip]="'Please select a concern'">
            <nz-select
              formControlName="auxiliaryConcernId"
              nzPlaceHolder="Select Concern"
            >
              <nz-option
                *ngFor="let item of auxiliaryConcernOptions"
                [nzValue]="item.value"
                [nzLabel]="item.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-divider nzText="Primary Therapist details"></nz-divider>
        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="primaryTherapistId" nzRequired
            >Primary Therapist</nz-form-label
          >
          <nz-form-control [nzErrorTip]="'Please select a therapist'">
            <nz-select
              formControlName="primaryTherapistId"
              nzPlaceHolder="Select Therapist"
            >
              <nz-option
                *ngFor="let item of therapistOptions"
                [nzValue]="item.value"
                [nzLabel]="item.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-divider nzText="Auxiliary Therapist details"></nz-divider>
        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="auxiliaryTherapistId" nzRequired
            >Auxiliary Therapist</nz-form-label
          >
          <nz-form-control
            [nzErrorTip]="'Please select an auxiliary therapist'"
          >
            <nz-select
              formControlName="auxiliaryTherapistId"
              nzPlaceHolder="Select Auxiliary Therapist"
            >
              <nz-option
                *ngFor="let item of auxiliaryTherapistOptions"
                [nzValue]="item.value"
                [nzLabel]="item.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Auxiliary Pack Expertise IDs (Dropdown) -->
        <nz-form-item nz-col nzSpan="24" class="mb-4">
          <nz-form-label nzFor="auxiliaryPackExpertiseIds" nzRequired
            >Auxiliary Therapist Expertise</nz-form-label
          >
          <nz-form-control
            [nzErrorTip]="'Please select at least one expertise'"
          >
            <nz-select
              formControlName="auxiliaryPackExpertiseIds"
              nzPlaceHolder="Select Expertise"
            >
              <nz-option
                *ngFor="let item of packExpertiseOptions"
                [nzValue]="item.value"
                [nzLabel]="item.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Submit Button -->
        <div class="flex justify-end mt-4">
          <button nz-button nzType="default" (click)="handleCloseDrawer()">
            Cancel
          </button>
          <button nz-button nzType="primary" class="ml-2">Submit</button>
          <!-- [disabled]="addPackSubscriptionForm.invalid" -->
        </div>
      </form>
    </nz-spin>
  </ng-container>
</nz-drawer>
